import { h, Component } from 'preact';
import util from 'preact-util';
import { observer } from 'mobx-preact';
import { Text, Localizer, withText } from 'preact-i18n';
import Markdown from 'preact-markdown';

import localUtil from '../../lib/util';
import fields from '../../lib/fields';

@observer
class NetsPaymentInProgress extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {
        const { week, isNew, hideAdmin, drawerLevel } = this.props;
        const { sections } = this.state;
        const { userStore, drugStore } = this.props.stores;
        const { user, isAdmin } = userStore;
        const { newDrug } = drugStore;
        const darkmode= util.getNestedValue(user, 'settings.darkmode');

        return (<>
            <div class='w-100 d-flex justify-content-center'>
                <div class='w-100' style='max-width: 960px; padding-top: 20px; padding-bottom: 100px;'>
                    {/* <div class='w-100 d-flex flex-column justify-content-start'>
                        <xmp>{JSON.stringify(user.settings, null, 2)}</xmp>
                    </div> */}
                    {/* <xmp>{JSON.stringify(newDrug, null, 4)}</xmp> */}
                    <div class='font-weight-lighter px-3 box-header mt-0'>
                        <Text id='dyrejournal.nets-payment-in-progress'>NETS Card payment in progress</Text>
                    </div>
                    <div class='bg-light d-flex flex-column justify-content-start h-100 pt-3'>

                        <div class='d-flex justify-content-center align-items-center h-100'>
                            <div class='spinner-border text-primary' role='status'>
                                <span class='sr-only'>Loading...</span>
                            </div>
                        </div>
                        <Text id='dyrejournal.nets-payment-in-progress-help'>Please wait while we process your payment.</Text>

                    </div>
                </div>
            </div>
        </>);
    }
}

export default NetsPaymentInProgress;
